<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('pt_locks.title') }}</h2>
      <p class="text-center">
        {{ $t('pt_locks.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <pt-locks-table/>
      </div>
    </div>
  </div>
</template>
<script>
  import PtLocksTable from './PtLocksTable'

  export default {
    name: 'operators',
    components: {
      PtLocksTable
    },
    computed: {

    },
  };
</script>
<style>
</style>
